"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormsColorIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _generated = require("../../../generated");
var _util = require("../../util");
const FormsColorIcon = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    color,
    backgroundColor,
    size,
    style,
    ...rest
  } = _ref;
  const svgColor = color ?? (0, _util.getColorVar)("forms", `var(${_util.SMAR_PREFIX}background--spectrum-orchid--stronger, #A531B9)`);
  const svgBackgroundColor = backgroundColor ?? (0, _util.getColorVar)("forms", `var(${_util.SMAR_PREFIX}background--spectrum-orchid--weakest, #F0C3F8)`, true);
  return /*#__PURE__*/_react.default.createElement(_generated.FormsIcon, (0, _extends2.default)({
    color: svgColor,
    ref: ref,
    size: size,
    backgroundColor: svgBackgroundColor
  }, rest, {
    style: {
      ...style
    }
  }));
});
exports.FormsColorIcon = FormsColorIcon;
FormsColorIcon.displayName = "FormsColorIcon";
//# sourceMappingURL=FormsColorIcon.js.map